
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import moment from 'moment';

export default defineComponent({
    name: 'ProductCard',
    props: ['listing', 'isDark'],
    methods: {
        ...mapActions(['removeListing']),
        formatDate(value: string) {
                if (value) {
                    return moment(String(value)).format('DD MMM YYYY HH:mm')
                }
                return 'N/A'
            }
    },
    computed: {
        }
    })

